import React, { useContext } from "react";
import { Grid, Form, Header } from "semantic-ui-react";
import FilterPageContext from "./FilterPageContext";

function Filters() {
    const ctx = useContext(FilterPageContext);

    let data: { key: string; value: any }[] = [];
    if (ctx.filters.status) data.push({ key: "status", value: ctx.filters.status });

    return (
        <>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Header as="h4">Filter</Header>
            </div>
            <Grid columns={5}>
                <Grid.Row>
                    <Grid.Column>
                        <Form.Dropdown
                            label="Status"
                            search
                            selection
                            placeholder="Select Status"
                            options={ctx.options.statusData}
                            value={ctx.filters.status}
                            onChange={(_, { value }) => ctx.filters.setStatus(value as string)}
                        />
                    </Grid.Column>

                    <Grid.Column>
                        &nbsp;
                        <div className="ui buttons">
                            <button
                                className="ui blue button"
                                onClick={ctx.filters.applyFilters}
                            >
                                Apply Filters
                            </button>
                            <button
                                className="ui button"
                                onClick={ctx.filters.clearAllFilters}
                            >
                                Clear
                            </button>
                        </div>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </>
    );
}

export default Filters;
